import {ValidationErrors, ValidatorFn} from '@angular/forms';
import {BooleanFn} from '@utils-lib';

export const conditionTrueValidator = (predicate: BooleanFn, message: string): ValidatorFn => (): ValidationErrors | null => {
  if (!predicate()) {
    return {
      conditionTrue: message
    };
  }
  return null;
};
